import { IconButton, Menu, MenuItem } from '@material-ui/core';
import EllipseIcon from '@material-ui/icons/MoreHoriz';
import React from 'react';
import styled from 'styled-components';
import ActionsContextV2 from '../ActionsContextV2';



const ProcedureManualCheckedButton = styled.img`
height:42px;
width:40px;
`;



const ActionItemMenuV2 = ({ action, isLevel1 }) => {


    const context = React.useContext(ActionsContextV2)

    const [anchorEl, setAnchorEl] = React.useState(null);

    return (
        <>
            <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                color='primary'
                onClick={event => {
                    setAnchorEl(event.currentTarget)
                }}>
                <EllipseIcon />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                {isLevel1 &&
                    <MenuItem
                        onClick={() => {
                            setAnchorEl(null);
                            context.setAlternateSdnAction(action);
                        }}
                    >
                        Add Alternate SDN
                    </MenuItem>
                }
                {!isLevel1 &&
                    <>
                       {/* <MenuItem
                            disabled={action.activeOneTimeDeviation}
                            onClick={() => {
                                setAnchorEl(null);
                                context.displayOneTimeDeviationDialog(action);
                            }}
                        >
                            Request a one-time deviation
                        </MenuItem> */}
                        <MenuItem
                            disabled={action.activeOneTimeDeviation}
                            onClick={() => {
                                setAnchorEl(null);
                                context.displayChangeComplianceDialog(action);
                            }}
                        >
                            Restart Procedure in workflow
                        </MenuItem>
                    </>
                }
            </Menu>
        </>
    );

}

export default ActionItemMenuV2;